import React, { Component } from 'react';
import InfoTooltip from './common/tooltip/info';
import { withNamespaces } from 'react-i18next';

class StatusView extends Component {
  render() {
    const { request, t } = this.props;

    if (request.status === 'pending') {
      return (
        <InfoTooltip info={t('aWaitingManagerApproval')}>
          <span className="fa fa-2x fa-clock-o text-info" />
        </InfoTooltip>
      );
    }

    if (request.status === 'accounting') {
      return (
        <InfoTooltip info={t('aWaitingAccountantApprovalInfo')}>
          <span className="fa fa-2x fa-clock-o text-info" />
        </InfoTooltip>
      );
    }

    if (request.status === 'waiting_for_cancelled') {
      return (
        <InfoTooltip info={t('awaitingCancellationApprove')}>
          <span className="fa fa-2x fa-clock-o text-info" />
        </InfoTooltip>
      );
    }

    if (request.status === 'waiting_for_accounting_cancelled') {
      return (
        <InfoTooltip info={t('aWaitingAccountantCancellation')}>
          <span className="fa fa-2x fa-clock-o text-info" />
        </InfoTooltip>
      );
    }

    if (request.status === 'cancelled') {
      return (
        <InfoTooltip info={t('cancelledInfo')}>
          <span className="fa fa-2x fa-ban text-danger" />
        </InfoTooltip>
      );
    }

    if (request.status === 'completed') {
      return (
        <InfoTooltip info={t('approvedInfo')}>
          <span className="fa fa-2x fa-check text-success" />
        </InfoTooltip>
      );
    }

    if (request.status === 'rejected') {
      return (
        <InfoTooltip info={t('rejectedInfo')}>
          <span className="fa fa-2x fa-ban text-danger" />
        </InfoTooltip>
      );
    }

    return (
      <InfoTooltip info={t('unknownReason')}>
        <span className="fa fa-2x fa-question text-muted" />
      </InfoTooltip>
    );
  }
}

export default withNamespaces()(StatusView);



// WEBPACK FOOTER //
// ./src/components/StatusView.js